import { TFilterValue } from '@/common/components/redesigned/Filter/types/filter';
import { TBaseFilterPayload } from '@/common/types/filter';

import { TPartnerCountry } from './common';

// id соответствуют справочнику event_status
export enum EventStatus {
  Planned = 1, // Планируемое
  Completed = 2, // Завершенное
  InProgress = 4, // В процессе
}

export type TEventsFilterDatesParams = {
  startDate: string;
  endDate: string;
};

export type TEventsFilterData = Partial<
  {
    regionRfIds: number[];
    isIncreasingOrder: boolean;
    partnerCountryId: number;
    typeId: number;
    statusId: number;
  } & TEventsFilterDatesParams
> & { [key: string]: TFilterValue };

export type TEventsFilterDataWithoutSorting = Partial<Omit<TEventsFilterData, 'isIncreasingOrder'>>;

export type TEventsTableItem = {
  id: number;
  organizer: string;
  partnerCountry: TPartnerCountry[];
  startEventDate: string;
  endEventDate: string;
  eventLocation: string;
  name: string | null;
  description: string | null;
  ferEventStatusId: number | null;
  eventStatus: string | null;
  ferEventVedTypeId: number | null;
  eventType: string | null;
  ferColorId: number | null;
  ferLegendId: number | null;
  significantFlag: boolean | null;
  isSystemEvent: boolean;
};

export type TEventsFilterPayload = TBaseFilterPayload<TEventsFilterData>;

export type TEventsFilterDataWithoutSortingPayload = TBaseFilterPayload<TEventsFilterDataWithoutSorting>;

export type TEventCreateForm = {
  id?: number;
  organizer: 'Минэкономразвития России';
  countryPartner: number[];
  countryPartnerClarified: boolean;
  ferEventVedTypeId: number | null;
  startEventDate: string;
  endEventDate: string;
  eventLocation: string;
  eventLocationClarified: boolean;
  name: string;
  ferEventStatusId: number | null;
  description: string;
  russianDelegation: string;
  foreignDelegation: string;
  contactPerson: string;
};

export type FEREventVedRequestDto = {
  startEventDate: string;
  endEventDate: string | null;
  name: string | null;
  eventLocation: string;
  description: string | null;
  russianDelegation: string | null;
  foreignDelegation: string | null;
  contactPerson: string | null;
  ferEventStatusId: number | null;
  ferEventVedTypeId: number | null;
  significantFlag: boolean | null;
  partnerCountry: { id: number }[];
};

export type TEventsTableActions = {
  onEdit: (row: TEventsTableItem) => void;
  onDeleted?: () => void;
};
